import { useEffect, useState } from 'react'

export default function ProgressBar({
  progressTime,
  subtitle,
}: {
  progressTime: number
  subtitle: string
}) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    // Reset progress whenever the duration changes
    setProgress(0)

    const intervalMs = (progressTime - 1000) / 100
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          return prev
        }
        return prev + 1
      })
    }, intervalMs)

    return () => clearInterval(interval)
  }, [progressTime])

  return (
    <div className="space-y-4">
      <div className="overflow-hidden rounded-full bg-[#EEEEEE]">
        <div
          className="bg-primary h-2.5 rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-[#AFAFAF]">{subtitle}</p>
        <p className="text-primary text-lg font-bold">{progress}%</p>
      </div>
    </div>
  )
}
